import { jsxs as _jsxs } from "react/jsx-runtime";
const labelStyle = {
    margin: 0,
    textAlign: 'right',
    padding: '0 5px',
    whiteSpace: 'nowrap',
};
export function CounterLabel(props) {
    const { style = {}, value } = props;
    return value && _jsxs("p", { style: { ...labelStyle, ...style }, children: [value, " "] });
}
